module.exports = __webpack_public_path__ + "static/media/19ESCAP15.b676986c.jpg";